<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-tag" titulo="CADASTRO DE NATUREZA DE CUSTO">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{ registro.ID || 'Novo' }}</strong>
            </span>
            <span v-if="registro.DESCRICAO" class="text-white-50">{{ registro.DESCRICAO }}</span>
          </div>
        </template>
        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" :disabled="isBusy" @click.stop.prevent="gravar">
            <i class="fa fa-save mr-1"></i> {{ registro.ID ? 'SALVAR' : 'GRAVAR' }}
          </b-button>
          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <b-card class="shadow-sm mb-3" :class="{'bg-dark border-secondary': isDark}">
            <b-row>
              <b-col md="2">
                <label class="modal-label-premium">ID</label>
                <b-form-input :value="registro.ID || 'Novo'" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado text-center font-weight-bold"></b-form-input>
              </b-col>
              <b-col md="10">
                <label class="modal-label-premium">Descrição *</label>
                <b-form-input v-model="registro.DESCRICAO" maxlength="100" class="rounded-pill shadow-xs" :class="{'is-invalid': !registro.DESCRICAO}"></b-form-input>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import Tools from '@/tools/tools.js'

export default {
  components: {
    HeaderPadrao
  },
  data() {
    return {
      isBusy: false,
      registro: {
        ID: null,
        DESCRICAO: ''
      }
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] }
  },
  methods: {
    voltar() {
      this.$router.push('/cadastros/natureza-custo/listagem')
    },
    async carregarRegistro(id) {
      this.isBusy = true
      try {
        const response = await this.$http.post('/api/protected/natureza-custo/pesquisar', { idPesquisa: id })
        if (response.data && response.data.length > 0) {
          this.registro = response.data[0]
        } else {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Registro não encontrado')
          this.voltar()
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || err.message || 'Erro inesperado')
      } finally {
        this.isBusy = false
      }
    },
    async gravar() {
      if (!this.registro.DESCRICAO) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A descrição é obrigatória.')
        return
      }

      this.isBusy = true
      try {
        const url = this.registro.ID ? '/api/protected/natureza-custo/edit' : '/api/protected/natureza-custo/post'
        await this.$http.post(url, this.registro)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Natureza de Custo gravada com sucesso!')
        this.voltar()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || err.message || 'Erro inesperado')
      } finally {
        this.isBusy = false
      }
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.carregarRegistro(this.$route.params.id)
    }
  }
}
</script>

<style scoped>
.modal-label-premium { font-size: 0.8rem; font-weight: 600; color: #475569; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.5rem; display: block; }
.campo-desabilitado { background-color: #f8fafc !important; color: #64748b; cursor: not-allowed; border-color: #e2e8f0; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); }
.btn-glass { border: none; font-weight: 600; transition: all 0.3s ease; text-transform: uppercase; letter-spacing: 0.05em; }
.btn-glass-success { background: rgba(34, 197, 94, 0.1); color: #16a34a; }
.btn-glass-success:hover:not(:disabled) { background: rgba(34, 197, 94, 0.2); color: #15803d; }
.btn-glass-success:disabled { opacity: 0.6; cursor: not-allowed; }
</style>



// WEBPACK FOOTER //
// src/views/cadastros/natureza-custo/NaturezaCustoCadastro.vue